import { Delete } from '../helpers';

export function DeleteProjectGroup(channel: number, groupUuid: string): Promise<{ deletedGroupUuid: string }> {
  return Delete({ path: `/v3/admin/channel/${channel}/event-groups/${groupUuid}` });
}
